import { InitialEnquiryModal } from './common/components/InitialEnquiryModal';
import { useInitialEnquiry } from './common/hooks/useInitialEnquiry';
import { ReadOnlyProductTable } from '../../common/ReadOnlyProductTable/ReadOnlyProductTable';
import Skeleton from 'react-loading-skeleton';
import { Box } from '../../common/ui/Box';

export const InitialEnquiryPopup = ({ isOpen, onDismiss, offerId }) => {
    const initialEnquiryQuery = useInitialEnquiry(offerId);
    const offer = initialEnquiryQuery.data;

    return (
        <InitialEnquiryModal
            isLoading={initialEnquiryQuery.isPending}
            offer={offer}
            isOpen={isOpen}
            onDismiss={onDismiss}
        >
            {initialEnquiryQuery.isPending ? (
                <Box display="grid" gap={16}>
                    <Skeleton height={32} />
                    <Skeleton height={32} />
                    <Skeleton height={32} />
                </Box>
            ) : null}
            {initialEnquiryQuery.isError ? <Error /> : null}
            {offer ? (
                <ReadOnlyProductTable
                    items={offer.items}
                    surcharges={offer.surcharges}
                    sampleKits={offer.samplekits}
                    totals={{ volume: offer.volume }}
                    showPrices={false}
                />
            ) : null}
        </InitialEnquiryModal>
    );
};
